<template>
  <v-list-tile
    v-if="!activeMappedItem"
    class="grey--text font-italic"
  >Selecciona un atributo para mapearlo a algún valor</v-list-tile>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("valueMapping", ["activeMappedItem"])
  }
};
</script>